import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { JobDescriptionDocumentSerializer } from '@app/model/serializer/jobDescriptionDocument-serializer';
import { JobDescriptionDocument } from '@app/model/jobDescriptionDocument';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class JobDescriptionDocumentService extends ApiService<JobDescriptionDocument> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job-description-document',
      new JobDescriptionDocumentSerializer());
  }
}
